import { render, staticRenderFns } from "./CompletionScreenAttach.vue?vue&type=template&id=40da836e&scoped=true&"
import script from "./CompletionScreenAttach.vue?vue&type=script&lang=js&"
export * from "./CompletionScreenAttach.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40da836e",
  null
  
)

export default component.exports